import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'EventVisualisationSkeleton',
  values: {
    numberOfMarketGroupCategoriesMenuItem: 2,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    scoreboardContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px',
        },
      },
    },
    scoreboardSkeletonPart: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '100%',
          height: '82px',
        },
      },
    },
    marketGroupCategoriesMenuContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          padding: '16px',
        },
      },
    },
    marketGroupCategoriesMenuItem: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '68px',
          height: '16px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
